// extracted by mini-css-extract-plugin
export var active = "_8f-a";
export var activeIndicator = "_8f-8";
export var animate = "_8f-9";
export var disabled = "_8f-b";
export var fullWidth = "_8f-2";
export var lg = "_8f-7";
export var md = "_8f-6";
export var redoButtonTabGroup = "_8f-0";
export var sm = "_8f-5";
export var tabButton = "_8f-3";
export var tabButtonsContainer = "_8f-1";
export var xs = "_8f-4";